import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewEn = () => {
    return <AnonymousView languageCode="en" />
}

export default AnonymousViewEn
